import campaignsEn from '@assets/i18n/campaigns/en.json';
import campaignsFr from '@assets/i18n/campaigns/fr.json';
import campaignsIt from '@assets/i18n/campaigns/it.json';
import commonEn from '@assets/i18n/common/en.json';
import commonFr from '@assets/i18n/common/fr.json';
import commonIt from '@assets/i18n/common/it.json';
import entitiesEn from '@assets/i18n/entities/en.json';
import entitiesFr from '@assets/i18n/entities/fr.json';
import entitiesIt from '@assets/i18n/entities/it.json';
import studioEn from '@assets/i18n/studio/en.json';
import studioFr from '@assets/i18n/studio/fr.json';
import studioIt from '@assets/i18n/studio/it.json';
import usersEn from '@assets/i18n/users/en.json';
import usersFr from '@assets/i18n/users/fr.json';
import usersIt from '@assets/i18n/users/it.json';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

/**
 * i18next setup. Imported for its side effect in `src/main.tsx` (`import './i18n'`),
 * which initialises i18next so `useTranslation` works app-wide.
 */
const resources = {
  en: {
    campaigns: campaignsEn,
    common: commonEn,
    entities: entitiesEn,
    studio: studioEn,
    users: usersEn
  },
  fr: {
    campaigns: campaignsFr,
    common: commonFr,
    entities: entitiesFr,
    studio: studioFr,
    users: usersFr
  },
  it: {
    campaigns: campaignsIt,
    common: commonIt,
    entities: entitiesIt,
    studio: studioIt,
    users: usersIt
  }
} as const;

// eslint-disable-next-line @typescript-eslint/no-floating-promises
void i18n
  .use(ICU)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'it'],
    defaultNS: 'common',
    ns: ['campaigns', 'common', 'entities', 'studio', 'users'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'app_language'
    },
    returnNull: false
  });

export default i18n;
